export const activeCompetition = {
  // MONTHLY CONTEST:
  gameTitleMonth: "Dead Zone",
  imgMonth: "/images/active_comp_img_monthly_prizes_deadzone.jpg",
  monthCaption: "Monthly Tournament | October 1st - October 31st",
  subTitleMonth: "First Place Wins $2,000",

  //OMNI ONE / WEEKLY CONTEST:
  gameTitleWeek: "Blackbeard",
  imgWeek: "https://cdn.shopify.com/s/files/1/0609/8989/8907/files/active_competition_o1_blackbeard.jpg?v=1761147216",
  weekCaption: "Omni One Tournament | July 1 - September 30",
  subTitleWeek: "Play anytime and be automatically entered in our Omni One contest!",
  buttonLabel: "See Leaderboard",
  alt: "Omni Arena Competitions",
  imgStart: 'start',
};

// LIST OF FILENAMES FOR CONTEST IMAGES:
//
// Omni One:
// Dead Zone: https://cdn.shopify.com/s/files/1/0609/8989/8907/files/active_competition_o1_deadzone.jpg?v=1761147216
// Core Defense: https://cdn.shopify.com/s/files/1/0609/8989/8907/files/active_competition_o1_coredefense.jpg?v=1761147216
// Gunslinger: https://cdn.shopify.com/s/files/1/0609/8989/8907/files/active_competition_o1_gunslinger.jpg?v=1761147216
// Blackbeard: https://cdn.shopify.com/s/files/1/0609/8989/8907/files/active_competition_o1_blackbeard.jpg?v=1761147216
//
// WEEKLY:
// Dead Zone: active_comp_img_weekly_prizes_deadzone.jpg
// Core Defense: active_comp_img_weekly_prizes_coredefense.jpg
// Gunslinger: active_comp_img_weekly_prizes_gunslinger.jpg
// Blackbeard: active_comp_img_weekly_prizes_blackbeard.jpg

// MONTHLY:
// Dead Zone: active_comp_img_monthly_prizes_deadzone.jpg
// Core Defense: active_comp_img_monthly_prizes_coredefense.jpg
// Gunslinger: active_comp_img_monthly_prizes_gunslinger.jpg
// Blackbeard: active_comp_img_monthly_prizes_blackbeard.jpg
